import React from "react";
import { useRef } from "react";
import { Button, makeStyles } from "@fluentui/react-components";
import { Dismiss32Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  container: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "9999", // Slightly lower than potential modals maybe
    display: "none",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    background: "black",
    "& video": {
      maxWidth: "100%",
      maxHeight: "100%",
      width: "100%",
      height: "100%",
      objectFit: "contain"
    },
    pointerEvents: "auto"
  },
  closeButton: {
    position: "absolute",
    top: "15px",
    right: "15px",
    zIndex: "9999",
    pointerEvents: "auto"
  }
});

export function Video2DContainer() {
  const classes = useStyles();
  const ref = useRef();

  const onClose = () => {
    if (ref.current) {
      // Move the video element to the end of the body
      const video = ref.current.querySelector("video");
      ref.current.style.display = "none";

      if (video) {
        video.style.display = "none";
        document.body.appendChild(video);
      }
    }
  };

  return (
    <div id="video-2d-container" ref={ref} className={classes.container}>
      <Button appearance="subtle" className={classes.closeButton} icon={<Dismiss32Regular />} onClick={onClose} />
    </div>
  );
}
